import { ReactNode } from 'react';
import { Box, Grid, SxProps, Theme } from '@mui/material';

type TabPanelProps = {
  children?: ReactNode;
  index: number | string;
  value: number | string;
  idPrefix: string;
  gridItem?: boolean;
  keepMounted?: boolean;
  className?: string;
  sx?: SxProps<Theme>;
};

export const a11yProps = (
  idPrefix: string,
  index: number,
): { id: string; 'aria-controls': string } => {
  return {
    id: `${idPrefix}-tab-${index}`,
    'aria-controls': `${idPrefix}-tabpanel-${index}`,
  };
};

export const TabPanel = (props: TabPanelProps): JSX.Element => {
  const {
    children,
    value,
    index,
    idPrefix,
    gridItem,
    keepMounted,
    className,
    sx,
  } = props;
  const isActive = value === index;
  const panelContent = (keepMounted || isActive) && children;

  if (gridItem) {
    return (
      <Grid
        role="tabpanel"
        hidden={!isActive}
        id={`${idPrefix}-tabpanel-${index}`}
        aria-labelledby={`${idPrefix}-tab-${index}`}
        className={className}
        sx={sx}
      >
        {panelContent}
      </Grid>
    );
  }

  return (
    <Box
      role="tabpanel"
      hidden={!isActive}
      id={`${idPrefix}-tabpanel-${index}`}
      aria-labelledby={`${idPrefix}-tab-${index}`}
      className={className}
      sx={sx}
    >
      {panelContent}
    </Box>
  );
};
